import { ALLERGENS, allergenLabel, allergenNum } from "@/lib/allergens";

export function AllergenBadges({ codes = [], lang = "it", size = "sm", testId }) {
  if (!codes.length) return null;
  const cls = size === "xs" ? "px-1 text-[9px]" : "px-1.5 py-0.5 text-[10px]";
  return (
    <div data-testid={testId} className="mt-1 flex flex-wrap gap-1">
      {codes.map((c) => { const n = allergenNum(c); return (
        <span key={c} title={allergenLabel(c, lang)} className={`inline-flex items-center gap-1 rounded-full bg-amber-100 font-bold text-amber-800 ${cls}`}>
          {n && <span className="rounded-full bg-amber-500 px-1 text-white">{n}</span>}{allergenLabel(c, lang)}
        </span>); })}
    </div>
  );
}

export function AllergenLegend({ codes, lang = "it", title }) {
  const used = codes ? ALLERGENS.filter((a) => codes.includes(a.code)) : ALLERGENS;
  if (!used.length) return null;
  return (
    <div data-testid="allergen-legend" className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-xs text-amber-900">
      <p className="mb-2 font-bold">{title}</p>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-1 sm:grid-cols-3">
        {used.map((a) => <li key={a.code}><span className="mr-1 inline-block w-5 rounded-full bg-amber-500 text-center font-bold text-white">{a.num}</span>{a[lang]}</li>)}
      </ul>
    </div>
  );
}

export function AllergenPicker({ value = [], onChange, lang = "it" }) {
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  return (
    <div data-testid="allergen-picker" className="flex flex-wrap gap-1.5">
      {ALLERGENS.map((a) => { const on = value.includes(a.code); return (
        <button key={a.code} type="button" data-testid={`allergen-${a.code}`} onClick={() => toggle(a.code)}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${on ? "bg-amber-500 text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:ring-amber-400"}`}>
          {a.num}. {a[lang]}
        </button>); })}
    </div>
  );
}
